// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { LaneGenerationScope } from "./Layout.LaneGenerationScope.gen";

export interface IGenerateLaneLinesRequest {
	scope: LaneGenerationScope;

	deviceIds: string[] | undefined;

	lookbackHours: number;

	fromDate: string | undefined;

	$type?: string | undefined;
}
export class GenerateLaneLinesRequest {
	constructor(data?: IGenerateLaneLinesRequest) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.fromDate) { this.fromDate = new Date(data.fromDate); }
	}

	scope: LaneGenerationScope = 0;

	deviceIds: string[] | undefined;

	lookbackHours: number = 0;

	fromDate: Date | undefined;

	static $type: string = "CoreApi.Models.Layout.GenerateLaneLinesRequest, ";
	$type?: string | undefined = GenerateLaneLinesRequest.$type;
}

